module.exports = {
	"articleTitle1": "State Street Starbucks reopens its doors",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Starbucks",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/arts/03musket-performs-woods-never27",
	"articleSnippet1": "Jan 23, 2014 ... The Starbucks located on the corner of South State and East Liberty streets \nreopened Thursday after five weeks of renovations after closing on ...",
	"articleSnippet2": "Mar 26, 2015 ... That's what director Adam Quinn told me in a Starbucks on the corner of State St. \nand Liberty St., where dozens of students tapped away at their ...",
	"foodRecommendations": [],
	"articleTitle2": "MUSKET performs 'Into the Woods' like never before",
	"address": "222 S State St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.27956,
		"lng": -83.741107
	},
	"totalMisc": 0,
	"categories": {
		"coffeeshop": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/starbucksstate.json
// module id = 980
// module chunks = 0